import { userRoles } from 'lib/src/shared/enums/dropdownEnums';
import { getDecodedJwtToken } from 'lib/src/utils/jwt';
import { useMemo } from 'react';
import { Challenge } from 'src/types/shared/Challenge';
import { ChallengeGroup } from 'src/types/shared/ChallengeGroup';

const useHasChallengeCrudPermissions = (challengeGroup: ChallengeGroup, challenge?: Challenge) => {
    const jwt = getDecodedJwtToken();
    const userID = jwt?.id;
    const isUserChallengeLead = challenge?.challengeLeadID === userID;
    const isSuperAdmin = jwt?.roles.includes(userRoles.superAdmin);

    const isUserPermitted = useMemo(() => {
        const permittedAdmins = challengeGroup.permittedAdmins?.map(admin => admin.id);

        if (!userID) {
            return false;
        } else {
            return permittedAdmins?.includes(+userID) || isUserChallengeLead || isSuperAdmin;
        }
    }, [challengeGroup.permittedAdmins, isSuperAdmin, isUserChallengeLead, userID]);

    return isUserPermitted;
};

export default useHasChallengeCrudPermissions;
